// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareProjectModal_wrapper__PUWnK","header":"ShareProjectModal_header__hqw56","controlWrapper":"ShareProjectModal_controlWrapper__ybYAr"};